// extracted by mini-css-extract-plugin
export default {"root":"ClientLoanProgramDetailPage_root__DSHBR","column":"ClientLoanProgramDetailPage_column__J37Wg"};